export default __webpack_public_path__ + "img/img_ezra-00cfac6f03b834632f0e6877e1221090.jpeg";